<template>
  <div>
    <head>
      <meta charset="utf-8" />
      <title>HOSPITAL MANAGEMENT INFORMATION SYSTEM | User registration</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="Keep your finances and membership up to date" name="description" />
      <meta content="Kelvin Njuguna Ndungu" name="author" />
      <!-- App favicon -->
      <link rel="shortcut icon" href="assets/images/favicon.svg">

      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <!-- Bootstrap select styling -->
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <!-- ========== Left Sidebar Start ========== -->
      <NavigationBar/>
      <!-- Left Sidebar End -->

      <!-- ============================================================== -->
      <!-- Start right Content here -->
      <!-- ============================================================== -->
      <div class="main-content">
        <div class="page-content">
          <div class="container-fluid">
            <!-- start page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">User Registration</h4>

                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                      <li class="breadcrumb-item active">Users</li>
                      <li class="breadcrumb-item active">Add User</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <!-- end page title -->

            <!-- Registration form -->
            <div class="row justify-content-center align-items-center d-flex">
              <div class="col-sm-12 col-md-10 col-lg-8">
                <div class="card">
                  <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                    <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                      <h4 class="card-title text-uppercase mb-0">
                        Add New User
                      </h4>
                    </div>
                  </div>

                  <div class="card-body">
                    <!-- Alert Messages -->
                    <div v-if="alert.success" class="alert alert-success alert-dismissible fade show" role="alert">
                      <i class="mdi mdi-check-all me-2"></i>
                      {{ message }}
                      <button type="button" class="btn-close" @click="clearAlerts" aria-label="Close"></button>
                    </div>

                    <div v-if="alert.info" class="alert alert-info alert-dismissible fade show" role="alert">
                      <i class="mdi mdi-information-outline me-2"></i>
                      {{ message }}
                      <button type="button" class="btn-close" @click="clearAlerts" aria-label="Close"></button>
                    </div>

                    <div v-if="alert.failed" class="alert alert-danger alert-dismissible fade show" role="alert">
                      <i class="mdi mdi-block-helper me-2"></i>
                      {{ message }}
                      <button type="button" class="btn-close" @click="clearAlerts" aria-label="Close"></button>
                    </div>

                    <!-- Success Modal -->
                    <div v-if="showSuccessModal" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5);">
                      <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-header bg-success text-white">
                            <h5 class="modal-title">
                              <i class="mdi mdi-check-circle me-2"></i>
                              User Created Successfully!
                            </h5>
                          </div>
                          <div class="modal-body text-center py-4">
                            <div class="mb-3">
                              <i class="mdi mdi-account-check text-success" style="font-size: 4rem;"></i>
                            </div>
                            <h5 class="text-success mb-3">Welcome to the System!</h5>
                            <p class="mb-2"><strong>Username:</strong> {{ createdUser.username }}</p>
                            <p class="mb-3"><strong>User ID:</strong> {{ createdUser.userId }}</p>
                            <div class="alert alert-info">
                              <i class="mdi mdi-email-outline me-2"></i>
                              Login credentials have been sent to the user's email address.
                            </div>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-success" @click="viewUsersList">
                              <i class="mdi mdi-account-multiple me-2"></i>
                              View Users
                            </button>
                            <button type="button" class="btn btn-outline-primary" @click="createAnotherUser">
                              <i class="mdi mdi-account-plus me-2"></i>
                              Create Another User
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <form @submit.prevent="registerUser">
                      <div class="row">
                        <div class="col-12">
                          <div class="bg-info border-2 bg-soft p-3 mb-4 d-flex align-items-center">
                            <p class="fw-semibold mb-0 pb-0 text-uppercase">General Information</p>
                          </div>
                        </div>

                        <!-- Personal Information Section -->
                        <div class="col-sm-6 col-md-8 col-lg-6">
                          <div class="row">
                            <div class="col-4 mb-3">
                              <div class="mb-3">
                                <label for="title-input" class="form-label">Title <strong class="text-danger fw-bold">*</strong></label>
                                <select v-model="userForm.title" @change="saveSelections" class="form-control" id="title-input" required>
                                  <option value="">Select Title</option>
                                  <option value="Mr">Mr</option>
                                  <option value="Mrs">Mrs</option>
                                  <option value="Miss">Miss</option>
                                  <option value="Ms">Ms</option>
                                  <option value="Dr">Dr</option>
                                  <option value="Prof">Prof</option>
                                  <option value="Mx">Mx</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-8 mb-3">
                              <div class="mb-3">
                                <label for="full-name-input" class="form-label">Full Name <strong class="text-danger fw-bold">*</strong></label>
                                <input v-model="userForm.fullName" type="text" class="form-control" id="full-name-input" placeholder="Enter Full Name" spellcheck="false" required>
                                <small class="text-muted">Enter the complete name (e.g., John Michael Doe)</small>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-6 col-md-4 col-lg-3 mb-3">
                          <div class="mb-3">
                            <label for="dob-input" class="form-label">Date Of Birth</label>
                            <input
                                v-model="userForm.dateOfBirth"
                                class="form-control"
                                type="date"
                                id="dob-input"
                                :max="maxDate"
                                :min="minDate"
                                @change="validateDateOfBirth"
                            >
                            <small v-if="dateError" class="text-danger">{{ dateError }}</small>
                          </div>
                        </div>

                        <div class="col-sm-6 col-md-4 col-lg-3 mb-3">
                          <div class="mb-3">
                            <label for="gender-input" class="form-label">Gender <strong class="text-danger fw-bold">*</strong></label>
                            <select v-model="userForm.gender" class="form-control" id="gender-input" required>
                              <option value="">Select Gender</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                              <option value="Other">Other</option>
                            </select>
                          </div>
                        </div>

                        <!-- Account Information -->
                        <!-- Username Field with Validation -->
                        <div class="col-sm-6 col-md-4 col-lg-3 mb-3">
                          <div class="mb-3">
                            <label for="username-input" class="form-label">Username <strong class="text-danger fw-bold">*</strong></label>
                            <div class="position-relative">
                              <input
                                  v-model="userForm.username"
                                  type="text"
                                  class="form-control"
                                  :class="getUsernameClass()"
                                  id="username-input"
                                  placeholder="Enter Username"
                                  spellcheck="false"
                                  required
                                  @input="validateUsername"
                                  @blur="checkUsernameAvailability">
                              <div v-if="usernameValidation.checking" class="position-absolute top-50 end-0 translate-middle-y me-3">
                                <div class="spinner-border spinner-border-sm text-primary" role="status">
                                  <span class="visually-hidden">Checking...</span>
                                </div>
                              </div>
                              <div v-else-if="usernameValidation.status === 'valid'" class="position-absolute top-50 end-0 translate-middle-y me-3">
                                <i class="bx bx-check-circle text-success fs-5"></i>
                              </div>
                              <div v-else-if="usernameValidation.status === 'invalid'" class="position-absolute top-50 end-0 translate-middle-y me-3">
                                <i class="bx bx-x-circle text-danger fs-5"></i>
                              </div>
                            </div>
                            <small v-if="usernameValidation.message" :class="usernameValidation.messageClass">
                              <i :class="usernameValidation.icon"></i> {{ usernameValidation.message }}
                            </small>
                            <small v-else class="text-muted">
                              <i class="bx bx-info-circle"></i> 3-50 characters, letters, numbers, underscore, dash
                            </small>
                          </div>
                        </div>

                        <!-- Email Field with Validation -->
                        <div class="col-sm-6 col-md-4 col-lg-3 mb-3">
                          <div class="mb-3">
                            <label for="email-input" class="form-label">Email Address <strong class="text-danger fw-bold">*</strong></label>
                            <div class="position-relative">
                              <input
                                  v-model="userForm.email"
                                  type="email"
                                  class="form-control"
                                  :class="getEmailClass()"
                                  id="email-input"
                                  placeholder="Enter Email Address"
                                  spellcheck="false"
                                  required
                                  @input="validateEmail"
                                  @blur="checkEmailAvailability">
                              <div v-if="emailValidation.checking" class="position-absolute top-50 end-0 translate-middle-y me-3">
                                <div class="spinner-border spinner-border-sm text-primary" role="status">
                                  <span class="visually-hidden">Checking...</span>
                                </div>
                              </div>
                              <div v-else-if="emailValidation.status === 'valid'" class="position-absolute top-50 end-0 translate-middle-y me-3">
                                <i class="bx bx-check-circle text-success fs-5"></i>
                              </div>
                              <div v-else-if="emailValidation.status === 'invalid'" class="position-absolute top-50 end-0 translate-middle-y me-3">
                                <i class="bx bx-x-circle text-danger fs-5"></i>
                              </div>
                            </div>
                            <small v-if="emailValidation.message" :class="emailValidation.messageClass">
                              <i :class="emailValidation.icon"></i> {{ emailValidation.message }}
                            </small>
                          </div>
                        </div>

                        <!-- Phone Field with Validation -->
                        <div class="col-sm-6 col-md-4 col-lg-3 mb-3">
                          <div class="mb-3">
                            <label for="phone-input" class="form-label">Phone Number <strong class="text-danger fw-bold">*</strong></label>
                            <div class="position-relative">
                              <input
                                  v-model="userForm.phone"
                                  type="tel"
                                  class="form-control"
                                  :class="getPhoneClass()"
                                  id="phone-input"
                                  placeholder="e.g., +251911234567"
                                  spellcheck="false"
                                  required
                                  @input="validatePhone"
                                  @blur="checkPhoneAvailability">
                              <div v-if="phoneValidation.checking" class="position-absolute top-50 end-0 translate-middle-y me-3">
                                <div class="spinner-border spinner-border-sm text-primary" role="status">
                                  <span class="visually-hidden">Checking...</span>
                                </div>
                              </div>
                              <div v-else-if="phoneValidation.status === 'valid'" class="position-absolute top-50 end-0 translate-middle-y me-3">
                                <i class="bx bx-check-circle text-success fs-5"></i>
                              </div>
                              <div v-else-if="phoneValidation.status === 'invalid'" class="position-absolute top-50 end-0 translate-middle-y me-3">
                                <i class="bx bx-x-circle text-danger fs-5"></i>
                              </div>
                            </div>
                            <small v-if="phoneValidation.message" :class="phoneValidation.messageClass">
                              <i :class="phoneValidation.icon"></i> {{ phoneValidation.message }}
                            </small>
                            <small v-else class="text-muted">
                              <i class="bx bx-info-circle"></i> Enter Ethiopian format: +251xxxxxxxxx
                            </small>
                          </div>
                        </div>

                        <!-- National ID Field with Validation -->
                        <div class="col-sm-6 col-md-4 col-lg-3 mb-3">
                          <div class="mb-3">
                            <label for="id-input" class="form-label">National ID <strong class="text-danger fw-bold">*</strong></label>
                            <div class="position-relative">
                              <input
                                  v-model="userForm.nationalId"
                                  type="text"
                                  class="form-control"
                                  :class="getNationalIdClass()"
                                  id="id-input"
                                  placeholder="Enter National ID"
                                  spellcheck="false"
                                  required
                                  @input="validateNationalId"
                                  @blur="checkNationalIdAvailability">
                              <div v-if="nationalIdValidation.checking" class="position-absolute top-50 end-0 translate-middle-y me-3">
                                <div class="spinner-border spinner-border-sm text-primary" role="status">
                                  <span class="visually-hidden">Checking...</span>
                                </div>
                              </div>
                              <div v-else-if="nationalIdValidation.status === 'valid'" class="position-absolute top-50 end-0 translate-middle-y me-3">
                                <i class="bx bx-check-circle text-success fs-5"></i>
                              </div>
                              <div v-else-if="nationalIdValidation.status === 'invalid'" class="position-absolute top-50 end-0 translate-middle-y me-3">
                                <i class="bx bx-x-circle text-danger fs-5"></i>
                              </div>
                            </div>
                            <small v-if="nationalIdValidation.message" :class="nationalIdValidation.messageClass">
                              <i :class="nationalIdValidation.icon"></i> {{ nationalIdValidation.message }}
                            </small>
                            <small v-else class="text-muted">
                              <i class="bx bx-info-circle"></i> Enter a valid Ethiopian National ID (10-16 digits)
                            </small>
                          </div>
                        </div>

                        <!-- Password Fields -->
                        <div class="col-sm-6 col-md-4 col-lg-3 mb-3">
                          <div class="mb-3">
                            <label for="password-input" class="form-label">Password <strong class="text-danger fw-bold">*</strong></label>
                            <div class="input-group">
                              <input v-model="userForm.password" :type="showPassword ? 'text' : 'password'" class="form-control" id="password-input" placeholder="Enter Password" required>
                              <button class="btn btn-light" type="button" @click="togglePassword">
                                <i :class="showPassword ? 'mdi mdi-eye-off-outline' : 'mdi mdi-eye-outline'"></i>
                              </button>
                            </div>
                            <small class="text-muted">
                              <i class="bx bx-info-circle"></i> Minimum 4 characters (can use PIN or password)
                            </small>
                          </div>
                        </div>

                        <div class="col-sm-6 col-md-4 col-lg-3 mb-3">
                          <div class="mb-3">
                            <label for="confirm-password-input" class="form-label">Confirm Password <strong class="text-danger fw-bold">*</strong></label>
                            <div class="input-group">
                              <input v-model="userForm.confirmPassword" :type="showConfirmPassword ? 'text' : 'password'" class="form-control" id="confirm-password-input" placeholder="Confirm Password" required>
                              <button class="btn btn-light" type="button" @click="toggleConfirmPassword">
                                <i :class="showConfirmPassword ? 'mdi mdi-eye-off-outline' : 'mdi mdi-eye-outline'"></i>
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- Location Information -->
                        <div class="col-sm-6 col-md-4 col-lg-3 mb-3">
                          <div class="mb-3">
                            <label for="region-input" class="form-label">Region</label>
                            <select v-model="userForm.regionId" @change="onRegionChange" class="form-control" id="region-input">
                              <option value="">Select Region</option>
                              <option v-for="region in regions" :key="region.region_id" :value="region.region_id">
                                {{ region.region_name }}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="col-sm-6 col-md-4 col-lg-3 mb-3">
                          <div class="mb-3">
                            <label for="zone-input" class="form-label">Zone</label>
                            <select v-model="userForm.zoneId" @change="onZoneChange" class="form-control" id="zone-input" :disabled="!userForm.regionId">
                              <option value="">Select Zone</option>
                              <option v-for="zone in zones" :key="zone.zone_id" :value="zone.zone_id">
                                {{ zone.zone_name }}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="col-sm-6 col-md-4 col-lg-3 mb-3">
                          <div class="mb-3">
                            <label for="woreda-input" class="form-label">Woreda</label>
                            <select v-model="userForm.woredaId" @change="saveSelections" class="form-control" id="woreda-input" :disabled="!userForm.zoneId">
                              <option value="">Select Woreda</option>
                              <option v-for="woreda in woredas" :key="woreda.woreda_id" :value="woreda.woreda_id">
                                {{ woreda.woreda_name }}
                              </option>
                            </select>
                          </div>
                        </div>

                        <!-- Work Information Section -->
                        <div class="col-12">
                          <div class="bg-info border-2 bg-soft p-3 mb-4 d-flex align-items-center">
                            <p class="fw-semibold mb-0 pb-0 text-uppercase">Work Information</p>
                          </div>
                        </div>

                        <div class="col-sm-12 col-md-6 col-lg-8">
                          <div class="row">
                            <div class="col-sm-6 col-md-6 mb-3">
                              <div class="mb-3">
                                <label for="role-input" class="form-label">System Role Categories<strong class="text-danger fw-bold">*</strong></label>
                                <select v-model="userForm.category" @change="saveSelections" class="form-control" id="role-input" required>
                                  <option value="">Select Role Category</option>
                                  <option v-for="role in roles" :key="role.category" :value="role.category">
                                    {{ role.category }}
                                  </option>
                                </select>
                                <small v-if="roles.length > 0" class="text-muted">{{ roles.length }} roles available</small>
                                <small v-else class="text-warning">{{ rolesLoading ? 'Loading roles...' : 'No roles found' }}</small>
                              </div>
                            </div>

                            <div class="col-sm-6 col-md-6 mb-3">
                              <div class="mb-3">
                                <label for="department-input" class="form-label">Department <strong class="text-danger fw-bold">*</strong></label>
                                <select v-model="userForm.departmentId" @change="saveSelections" class="form-control" id="department-input" required>
                                  <option value="">Select Department</option>
                                  <option v-for="dept in departments" :key="dept.department_id" :value="dept.department_id">
                                    {{ dept.department_name }}
                                  </option>
                                </select>
                              </div>
                            </div>

                            <div class="col-sm-6 col-md-6 mb-3">
                              <div class="mb-3">
                                <label for="employment-type-input" class="form-label">Employment Type <strong class="text-danger fw-bold">*</strong></label>
                                <select v-model="userForm.employmentTypeId" @change="saveSelections" class="form-control" id="employment-type-input" required>
                                  <option value="">Select Employment Type</option>
                                  <option v-for="type in employmentTypes" :key="type.employment_type_id" :value="type.employment_type_id">
                                    {{ type.employment_type_name }}
                                  </option>
                                </select>
                              </div>
                            </div>

                            <div class="col-sm-6 col-md-6 mb-3">
                              <div class="mb-3">
                                <label for="affiliation-input" class="form-label">Affiliation</label>
                                <select v-model="userForm.affiliationId" @change="saveSelections" class="form-control" id="affiliation-input">
                                  <option value="">Select Affiliation</option>
                                  <option v-for="institution in affiliatedInstitutions" :key="institution.institution_id" :value="institution.institution_id">
                                    {{ institution.institution_name }}
                                  </option>
                                </select>
                              </div>
                            </div>

                            <div class="col-sm-6 col-md-6 mb-3">
                              <div class="mb-3">
                                <label for="employee-id-input" class="form-label">Employee ID</label>
                                <input v-model="userForm.employeeId" type="text" class="form-control" id="employee-id-input" placeholder="Enter Employee ID">
                              </div>
                            </div>

                            <div class="col-sm-6 col-md-6 mb-3">
                              <div class="mb-3">
                                <label for="hospital-input" class="form-label">Hospital (if applicable)</label>
                                <select v-model="userForm.hospitalId" @change="saveSelections" class="form-control" id="hospital-input">
                                  <option value="">Select Hospital</option>
                                  <option v-for="hospital in hospitals" :key="hospital.hospital_id" :value="hospital.hospital_id">
                                    {{ hospital.hospital_name }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-12 col-md-6 col-lg-4">
                          <div class="mb-3">
                            <label for="notes-input" class="form-label">Notes</label>
                            <textarea v-model="userForm.notes" cols="50" rows="6" class="form-control" id="notes-input" placeholder="Start Typing Details"></textarea>
                            <small>Provide further details, including terms of work if necessary.</small>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div class="card-footer bg-white border-top py-3">
                    <div class="col-12">
                      <button type="submit" @click="registerUser" :disabled="loading || !isFormValid" class="btn btn-primary waves-effect waves-light text-uppercase">
                        <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        <i v-else class="mdi mdi-content-save-outline font-size-16 align-middle me-2"></i>
                        {{ loading ? 'Creating User...' : 'Create User' }}
                      </button>
                      <button type="button" @click="clearFormCompletely" :disabled="loading" class="btn btn-outline-secondary waves-effect text-uppercase mx-3">
                        <i class="mdi mdi-close font-size-16 align-middle me-2"></i> Clear Form
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import { authUrl, executeJson } from "@/api";
import router from "@/router";

export default {
  name: "UserRegistration",
  components: { NavigationBar },
  data() {
    return {
      loading: false,
      rolesLoading: false,
      showPassword: false,
      showConfirmPassword: false,

      // Form data
      userForm: {
        title: '',
        fullName: '',
        dateOfBirth: '',
        gender: '',
        username: '',
        email: '',
        phone: '',
        nationalId: '',
        password: '',
        confirmPassword: '',
        regionId: '',
        zoneId: '',
        woredaId: '',
        category: '',
        departmentId: '',
        employmentTypeId: '',
        affiliationId: '',
        hospitalId: '',
        employeeId: '',
        notes: ''
      },

      // Validation states
      usernameValidation: {
        checking: false,
        status: '',
        message: '',
        messageClass: 'text-muted',
        icon: 'bx bx-info-circle',
        isValid: false
      },

      emailValidation: {
        checking: false,
        status: '',
        message: '',
        messageClass: 'text-muted',
        icon: 'bx bx-info-circle',
        isValid: false
      },

      phoneValidation: {
        checking: false,
        status: '',
        message: '',
        messageClass: 'text-muted',
        icon: 'bx bx-info-circle',
        isValid: false
      },

      nationalIdValidation: {
        checking: false,
        status: '',
        message: '',
        messageClass: 'text-muted',
        icon: 'bx bx-info-circle',
        isValid: false
      },

      // Alert states
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: '',
      dateError: '',
      showSuccessModal: false,
      createdUser: {
        username: '',
        userId: ''
      },

      // Date validation
      maxDate: '',
      minDate: '',

      // Dropdown data - Initialize as empty arrays
      regions: [],
      zones: [],
      woredas: [],
      roles: [],
      departments: [],
      employmentTypes: [],
      affiliatedInstitutions: [],
      hospitals: []
    };
  },

  computed: {
    isFormValid() {
      // Check required fields
      const requiredFieldsValid = this.userForm.title &&
          this.userForm.fullName &&
          this.userForm.gender &&
          this.userForm.username &&
          this.userForm.email &&
          this.userForm.phone &&
          this.userForm.nationalId &&
          this.userForm.password &&
          this.userForm.confirmPassword &&
          this.userForm.category &&
          this.userForm.departmentId &&
          this.userForm.employmentTypeId;

      // Check validation states
      const usernameValid = this.usernameValidation.isValid;
      const emailValid = this.emailValidation.isValid;
      const phoneValid = this.phoneValidation.isValid;
      const nationalIdValid = this.nationalIdValidation.isValid;

      // Check password match
      const passwordMatch = this.userForm.password === this.userForm.confirmPassword;
      const passwordLength = this.userForm.password.length >= 4;

      return requiredFieldsValid && usernameValid && emailValid && phoneValid && nationalIdValid && passwordMatch && passwordLength;
    }
  },

  mounted() {
    console.log("Component mounted, starting initialization...");
    this.checkAuthentication();
    this.initializeDateLimits();
    this.loadInitialData();
  },

  methods: {
    checkAuthentication() {
      // Check if user is logged in
      const isLoggedIn = sessionStorage.getItem("isLoggedIn");
      const authToken = localStorage.getItem("authToken");

      if (!isLoggedIn || !authToken) {
        router.push('/login');
      }
    },

    initializeDateLimits() {
      // Set maximum date to today (can't be born in the future)
      const today = new Date();
      this.maxDate = today.toISOString().split('T')[0];

      // Set minimum date to 120 years ago (reasonable age limit)
      const minYear = today.getFullYear() - 120;
      const minDate = new Date(minYear, 0, 1);
      this.minDate = minDate.toISOString().split('T')[0];
    },

    async loadInitialData() {
      try {
        // Load all dropdowns in parallel for better performance
        await Promise.all([
          this.loadRegions(),
          this.getCategories(),
          this.loadDepartments(),
          this.loadEmploymentTypes(),
          this.loadAffiliatedInstitutions(),
          this.loadHospitals()
        ]);

        // After all data is loaded, restore saved selections
        this.$nextTick(() => {
          this.loadSavedSelections();
        });
      } catch (error) {
        this.showAlert('failed', 'Failed to load some dropdown data. Please refresh the page.');
      }
    },

    // Username validation methods
    validateUsername() {
      const username = this.userForm.username.trim();

      this.usernameValidation.checking = false;
      this.usernameValidation.status = '';
      this.usernameValidation.isValid = false;

      if (!username) {
        this.usernameValidation.message = 'Username is required';
        this.usernameValidation.messageClass = 'text-danger';
        this.usernameValidation.icon = 'bx bx-error-circle';
        this.usernameValidation.status = 'invalid';
        return;
      }

      // Username format: alphanumeric, underscore, dash, 3-50 characters
      const usernamePattern = /^[a-zA-Z0-9_-]{3,50}$/;

      if (!usernamePattern.test(username)) {
        this.usernameValidation.status = 'invalid';
        this.usernameValidation.message = 'Invalid format. Use 3-50 characters: letters, numbers, underscore, dash';
        this.usernameValidation.messageClass = 'text-danger';
        this.usernameValidation.icon = 'bx bx-error-circle';
        this.usernameValidation.isValid = false;
        return;
      }

      // Format is valid, but need to check availability
      this.usernameValidation.message = 'Checking availability...';
      this.usernameValidation.messageClass = 'text-info';
      this.usernameValidation.icon = 'bx bx-info-circle';
    },

    async checkUsernameAvailability() {
      const username = this.userForm.username.trim();

      if (!username || !/^[a-zA-Z0-9_-]{3,50}$/.test(username)) {
        return;
      }

      this.usernameValidation.checking = true;

      const data = {
        "function": "checkUsernameAvailability",
        "username": username
      };

      try {
        const res = await executeJson(data, authUrl);

        if (res.data.success) {
          if (res.data.data.isAvailable) {
            this.usernameValidation.status = 'valid';
            this.usernameValidation.message = 'Username is available';
            this.usernameValidation.messageClass = 'text-success';
            this.usernameValidation.icon = 'bx bx-check-circle';
            this.usernameValidation.isValid = true;
          } else {
            this.usernameValidation.status = 'invalid';
            this.usernameValidation.message = `Username already taken: ${res.data.data.existingUser}`;
            this.usernameValidation.messageClass = 'text-danger';
            this.usernameValidation.icon = 'bx bx-x-circle';
            this.usernameValidation.isValid = false;
          }
        } else {
          this.usernameValidation.status = 'invalid';
          this.usernameValidation.message = 'Error checking username availability';
          this.usernameValidation.messageClass = 'text-danger';
          this.usernameValidation.icon = 'bx bx-error-circle';
          this.usernameValidation.isValid = false;
        }
      } catch (e) {
        console.error("Failed to check username:", e);
        this.usernameValidation.status = 'invalid';
        this.usernameValidation.message = 'Error checking username availability';
        this.usernameValidation.messageClass = 'text-danger';
        this.usernameValidation.icon = 'bx bx-error-circle';
        this.usernameValidation.isValid = false;
      } finally {
        this.usernameValidation.checking = false;
      }
    },

    // Email validation methods
    validateEmail() {
      const email = this.userForm.email.trim();

      this.emailValidation.checking = false;
      this.emailValidation.status = '';
      this.emailValidation.isValid = false;

      if (!email) {
        this.emailValidation.message = 'Email is required';
        this.emailValidation.messageClass = 'text-danger';
        this.emailValidation.icon = 'bx bx-error-circle';
        this.emailValidation.status = 'invalid';
        return;
      }

      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      if (!emailPattern.test(email)) {
        this.emailValidation.status = 'invalid';
        this.emailValidation.message = 'Invalid email format';
        this.emailValidation.messageClass = 'text-danger';
        this.emailValidation.icon = 'bx bx-error-circle';
        this.emailValidation.isValid = false;
        return;
      }

      // Format is valid, but need to check availability
      this.emailValidation.message = 'Checking availability...';
      this.emailValidation.messageClass = 'text-info';
      this.emailValidation.icon = 'bx bx-info-circle';
    },

    async checkEmailAvailability() {
      const email = this.userForm.email.trim();

      if (!email || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
        return;
      }

      this.emailValidation.checking = true;

      const data = {
        "function": "checkUserEmailAvailability",
        "email": email
      };

      try {
        const res = await executeJson(data, authUrl);

        if (res.data.success) {
          if (res.data.data.isAvailable) {
            this.emailValidation.status = 'valid';
            this.emailValidation.message = 'Email is available';
            this.emailValidation.messageClass = 'text-success';
            this.emailValidation.icon = 'bx bx-check-circle';
            this.emailValidation.isValid = true;
          } else {
            this.emailValidation.status = 'invalid';
            this.emailValidation.message = `Email already registered: ${res.data.data.existingUser}`;
            this.emailValidation.messageClass = 'text-danger';
            this.emailValidation.icon = 'bx bx-x-circle';
            this.emailValidation.isValid = false;
          }
        } else {
          this.emailValidation.status = 'invalid';
          this.emailValidation.message = 'Error checking email availability';
          this.emailValidation.messageClass = 'text-danger';
          this.emailValidation.icon = 'bx bx-error-circle';
          this.emailValidation.isValid = false;
        }
      } catch (e) {
        console.error("Failed to check email:", e);
        this.emailValidation.status = 'invalid';
        this.emailValidation.message = 'Error checking email availability';
        this.emailValidation.messageClass = 'text-danger';
        this.emailValidation.icon = 'bx bx-error-circle';
        this.emailValidation.isValid = false;
      } finally {
        this.emailValidation.checking = false;
      }
    },

    // Phone validation methods
    validatePhone() {
      const phone = this.userForm.phone.trim();

      this.phoneValidation.checking = false;
      this.phoneValidation.status = '';
      this.phoneValidation.isValid = false;

      if (!phone) {
        this.phoneValidation.message = 'Phone number is required';
        this.phoneValidation.messageClass = 'text-danger';
        this.phoneValidation.icon = 'bx bx-error-circle';
        this.phoneValidation.status = 'invalid';
        return;
      }

      const cleanPhone = phone.replace(/[\s\-\(\)]/g, '');
      const ethiopianPattern = /^\+251[79]\d{8}$/;

      if (!ethiopianPattern.test(cleanPhone)) {
        this.phoneValidation.status = 'invalid';
        this.phoneValidation.message = 'Invalid format. Use: +251xxxxxxxxx';
        this.phoneValidation.messageClass = 'text-danger';
        this.phoneValidation.icon = 'bx bx-error-circle';
        this.phoneValidation.isValid = false;
        return;
      }

      // Format is valid, but need to check availability
      this.userForm.phone = cleanPhone;
      this.phoneValidation.message = 'Checking availability...';
      this.phoneValidation.messageClass = 'text-info';
      this.phoneValidation.icon = 'bx bx-info-circle';
    },

    async checkPhoneAvailability() {
      const phone = this.userForm.phone.trim();
      const ethiopianPattern = /^\+251[79]\d{8}$/;

      if (!phone || !ethiopianPattern.test(phone)) {
        return;
      }

      this.phoneValidation.checking = true;

      const data = {
        "function": "checkUserPhoneAvailability",
        "phone": phone
      };

      try {
        const res = await executeJson(data, authUrl);

        if (res.data.success) {
          if (res.data.data.isAvailable) {
            this.phoneValidation.status = 'valid';
            this.phoneValidation.message = 'Phone number is available';
            this.phoneValidation.messageClass = 'text-success';
            this.phoneValidation.icon = 'bx bx-check-circle';
            this.phoneValidation.isValid = true;
          } else {
            this.phoneValidation.status = 'invalid';
            this.phoneValidation.message = `Phone already registered: ${res.data.data.existingUser}`;
            this.phoneValidation.messageClass = 'text-danger';
            this.phoneValidation.icon = 'bx bx-x-circle';
            this.phoneValidation.isValid = false;
          }
        } else {
          this.phoneValidation.status = 'invalid';
          this.phoneValidation.message = 'Error checking phone availability';
          this.phoneValidation.messageClass = 'text-danger';
          this.phoneValidation.icon = 'bx bx-error-circle';
          this.phoneValidation.isValid = false;
        }
      } catch (e) {
        console.error("Failed to check phone:", e);
        this.phoneValidation.status = 'invalid';
        this.phoneValidation.message = 'Error checking phone availability';
        this.phoneValidation.messageClass = 'text-danger';
        this.phoneValidation.icon = 'bx bx-error-circle';
        this.phoneValidation.isValid = false;
      } finally {
        this.phoneValidation.checking = false;
      }
    },

    // National ID validation methods
    validateNationalId() {
      const nationalId = this.userForm.nationalId.trim();

      this.nationalIdValidation.checking = false;
      this.nationalIdValidation.status = '';
      this.nationalIdValidation.isValid = false;

      if (!nationalId) {
        this.nationalIdValidation.message = 'National ID is required';
        this.nationalIdValidation.messageClass = 'text-danger';
        this.nationalIdValidation.icon = 'bx bx-error-circle';
        this.nationalIdValidation.status = 'invalid';
        return;
      }

      // No pattern validation - just check availability
      this.nationalIdValidation.message = 'Checking availability...';
      this.nationalIdValidation.messageClass = 'text-info';
      this.nationalIdValidation.icon = 'bx bx-info-circle';
    },

    async checkNationalIdAvailability() {
      const nationalId = this.userForm.nationalId.trim();

      if (!nationalId) {
        return;
      }

      this.nationalIdValidation.checking = true;

      const data = {
        "function": "checkUserNationalIdAvailability",
        "nationalId": nationalId
      };

      try {
        const res = await executeJson(data, authUrl);

        if (res.data.success) {
          if (res.data.data.isAvailable) {
            this.nationalIdValidation.status = 'valid';
            this.nationalIdValidation.message = 'National ID is available';
            this.nationalIdValidation.messageClass = 'text-success';
            this.nationalIdValidation.icon = 'bx bx-check-circle';
            this.nationalIdValidation.isValid = true;
          } else {
            this.nationalIdValidation.status = 'invalid';
            const isMember = res.data.data.isMember ? ' (CBHI Member)' : '';
            this.nationalIdValidation.message = `ID already registered: ${res.data.data.existingUser}${isMember}`;
            this.nationalIdValidation.messageClass = 'text-danger';
            this.nationalIdValidation.icon = 'bx bx-x-circle';
            this.nationalIdValidation.isValid = false;
          }
        } else {
          this.nationalIdValidation.status = 'invalid';
          this.nationalIdValidation.message = 'Error checking National ID';
          this.nationalIdValidation.messageClass = 'text-danger';
          this.nationalIdValidation.icon = 'bx bx-error-circle';
          this.nationalIdValidation.isValid = false;
        }
      } catch (e) {
        console.error("Failed to check National ID:", e);
        this.nationalIdValidation.status = 'invalid';
        this.nationalIdValidation.message = 'Error checking National ID';
        this.nationalIdValidation.messageClass = 'text-danger';
        this.nationalIdValidation.icon = 'bx bx-error-circle';
        this.nationalIdValidation.isValid = false;
      } finally {
        this.nationalIdValidation.checking = false;
      }
    },

    // Helper methods for CSS classes
    getUsernameClass() {
      const baseClass = 'form-control';
      if (this.usernameValidation.status === 'valid') {
        return `${baseClass} is-valid`;
      } else if (this.usernameValidation.status === 'invalid') {
        return `${baseClass} is-invalid`;
      }
      return baseClass;
    },

    getEmailClass() {
      const baseClass = 'form-control';
      if (this.emailValidation.status === 'valid') {
        return `${baseClass} is-valid`;
      } else if (this.emailValidation.status === 'invalid') {
        return `${baseClass} is-invalid`;
      }
      return baseClass;
    },

    getPhoneClass() {
      const baseClass = 'form-control';
      if (this.phoneValidation.status === 'valid') {
        return `${baseClass} is-valid`;
      } else if (this.phoneValidation.status === 'invalid') {
        return `${baseClass} is-invalid`;
      }
      return baseClass;
    },

    getNationalIdClass() {
      const baseClass = 'form-control';
      if (this.nationalIdValidation.status === 'valid') {
        return `${baseClass} is-valid`;
      } else if (this.nationalIdValidation.status === 'invalid') {
        return `${baseClass} is-invalid`;
      }
      return baseClass;
    },

    // Save selected values to localStorage for persistent state
    saveSelections() {
      const selectionsToSave = {
        title: this.userForm.title,
        regionId: this.userForm.regionId,
        zoneId: this.userForm.zoneId,
        woredaId: this.userForm.woredaId,
        category: this.userForm.category,
        departmentId: this.userForm.departmentId,
        employmentTypeId: this.userForm.employmentTypeId,
        affiliationId: this.userForm.affiliationId,
        hospitalId: this.userForm.hospitalId
      };

      localStorage.setItem('userRegistrationSelections', JSON.stringify(selectionsToSave));
    },

    // Load saved selections from localStorage
    async loadSavedSelections() {
      try {
        const savedSelections = localStorage.getItem('userRegistrationSelections');
        if (savedSelections) {
          const selections = JSON.parse(savedSelections);

          // Restore title
          if (selections.title) {
            this.userForm.title = selections.title;
          }

          // Restore work information selections
          if (selections.category && this.roles.some(r => r.role_id == selections.category)) {
            this.userForm.category = selections.category;
          }

          if (selections.departmentId && this.departments.some(d => d.department_id == selections.departmentId)) {
            this.userForm.departmentId = selections.departmentId;
          }

          if (selections.employmentTypeId && this.employmentTypes.some(e => e.employment_type_id == selections.employmentTypeId)) {
            this.userForm.employmentTypeId = selections.employmentTypeId;
          }

          if (selections.affiliationId && this.affiliatedInstitutions.some(a => a.institution_id == selections.affiliationId)) {
            this.userForm.affiliationId = selections.affiliationId;
          }

          if (selections.hospitalId && this.hospitals.some(h => h.hospital_id == selections.hospitalId)) {
            this.userForm.hospitalId = selections.hospitalId;
          }

          // Restore location selections with dependency loading
          if (selections.regionId && this.regions.some(r => r.region_id == selections.regionId)) {
            this.userForm.regionId = selections.regionId;

            // Load zones for the selected region
            await this.loadZones();

            if (selections.zoneId && this.zones.some(z => z.zone_id == selections.zoneId)) {
              this.userForm.zoneId = selections.zoneId;

              // Load woredas for the selected zone
              await this.loadWoredas();

              if (selections.woredaId && this.woredas.some(w => w.woreda_id == selections.woredaId)) {
                this.userForm.woredaId = selections.woredaId;
              }
            }
          }
        }
      } catch (error) {
        console.error("Error loading saved selections:", error);
      }
    },

    // Clear saved selections from localStorage
    clearSavedSelections() {
      localStorage.removeItem('userRegistrationSelections');
    },

    // Enhanced region change handler
    async onRegionChange() {
      await this.loadZones();
      this.saveSelections();
    },

    // Enhanced zone change handler
    async onZoneChange() {
      await this.loadWoredas();
      this.saveSelections();
    },

    async loadRegions() {
      const data = {
        function: "getRegions"
      };

      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success && response.data.data) {
          this.regions = response.data.data.regions || [];
        }
      } catch (error) {
        console.error("Error loading regions:", error);
      }
    },

    async loadZones() {
      if (!this.userForm.regionId) {
        this.zones = [];
        this.userForm.zoneId = '';
        this.woredas = [];
        this.userForm.woredaId = '';
        return;
      }

      const data = {
        function: "getZones",
        regionId: this.userForm.regionId
      };

      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success && response.data.data) {
          this.zones = response.data.data.zones || [];
          // Reset dependent fields
          this.userForm.zoneId = '';
          this.woredas = [];
          this.userForm.woredaId = '';
        }
      } catch (error) {
        console.error("Error loading zones:", error);
      }
    },

    async loadWoredas() {
      if (!this.userForm.zoneId) {
        this.woredas = [];
        this.userForm.woredaId = '';
        return;
      }

      const data = {
        function: "getWoredas",
        zoneId: this.userForm.zoneId
      };

      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success && response.data.data) {
          this.woredas = response.data.data.woredas || [];
          // Reset dependent field
          this.userForm.woredaId = '';
        }
      } catch (error) {
        console.error("Error loading woredas:", error);
      }
    },

    async getCategories() {
      this.rolesLoading = true;

      const data = {
        function: "getCategories"
      };

      try {
        const response = await executeJson(data, authUrl);

        // Check multiple possible response structures
        let rolesData = null;

        if (response.data && response.data.success) {
          if (response.data.data && response.data.data.data && response.data.data.data.categories) {
            rolesData = response.data.data.data.categories;
          } else if (response.data.data && response.data.data.categories) {
            rolesData = response.data.data.categories;
          } else if (response.data.categories) {
            rolesData = response.data.categories;
          }

          if (rolesData && Array.isArray(rolesData)) {
            this.roles = [...rolesData];
          } else {
            this.roles = [];
          }
        } else {
          this.roles = [];
        }
      } catch (error) {
        console.error("Error loading roles:", error);
        this.roles = [];
        this.showAlert('failed', 'Failed to load roles. Please try again.');
      } finally {
        this.rolesLoading = false;
      }
    },

    async loadDepartments() {
      const data = {
        function: "getDepartments",
        status: "active"
      };

      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success && response.data.data) {
          this.departments = response.data.data.departments || [];
        }
      } catch (error) {
        console.error("Error loading departments:", error);
      }
    },

    async loadEmploymentTypes() {
      const data = {
        function: "getEmploymentTypes",
        status: "active"
      };

      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success && response.data.data) {
          this.employmentTypes = response.data.data.employmentTypes || [];
        }
      } catch (error) {
        console.error("Error loading employment types:", error);
      }
    },

    async loadAffiliatedInstitutions() {
      const data = {
        function: "getAffiliatedInstitutions",
        status: "active"
      };

      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success && response.data.data) {
          this.affiliatedInstitutions = response.data.data.institutions || [];
        }
      } catch (error) {
        console.error("Error loading affiliated institutions:", error);
      }
    },

    async loadHospitals() {
      const data = {
        function: "getHospitals",
        status: "active"
      };

      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success && response.data.data) {
          this.hospitals = response.data.data.hospitals || [];
        }
      } catch (error) {
        console.error("Error loading hospitals:", error);
      }
    },

    viewUsersList() {
      this.showSuccessModal = false;
      this.clearAlerts();
      // Navigate to user list page
      router.push('/user-userlist');
    },

    createAnotherUser() {
      this.showSuccessModal = false;
      this.clearAlerts();
      // Clear entire form for creating another user
      this.clearForm(false);
    },

    // New method to handle clear button click
    clearFormCompletely() {
      // Clear entire form including persistent data
      this.clearForm(false);
    },

    validateDateOfBirth() {
      this.dateError = '';

      if (!this.userForm.dateOfBirth) {
        return;
      }

      const selectedDate = new Date(this.userForm.dateOfBirth);
      const today = new Date();

      // Clear time components for accurate comparison
      today.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);

      // Check if date is in the future
      if (selectedDate > today) {
        this.dateError = 'Date of birth cannot be in the future';
        this.userForm.dateOfBirth = '';
        return;
      }

      // Check if date is too far in the past (over 120 years ago)
      const maxAge = new Date();
      maxAge.setFullYear(maxAge.getFullYear() - 120);
      maxAge.setHours(0, 0, 0, 0);

      if (selectedDate < maxAge) {
        this.dateError = 'Date of birth cannot be more than 120 years ago';
        this.userForm.dateOfBirth = '';
        return;
      }

      // Check if person is at least 16 years old (minimum working age)
      const minAge = new Date();
      minAge.setFullYear(minAge.getFullYear() - 16);
      minAge.setHours(0, 0, 0, 0);

      if (selectedDate > minAge) {
        this.dateError = 'Person must be at least 16 years old';
        this.userForm.dateOfBirth = '';
        return;
      }

      // Additional validation for invalid dates
      const inputDate = this.userForm.dateOfBirth;
      const parts = inputDate.split('-');
      if (parts.length === 3) {
        const year = parseInt(parts[0]);
        const month = parseInt(parts[1]);
        const day = parseInt(parts[2]);

        // Check for valid month
        if (month < 1 || month > 12) {
          this.dateError = 'Invalid month';
          this.userForm.dateOfBirth = '';
          return;
        }

        // Check for valid day based on month and year
        const daysInMonth = new Date(year, month, 0).getDate();
        if (day < 1 || day > daysInMonth) {
          this.dateError = `Invalid day for ${this.getMonthName(month)}. Maximum ${daysInMonth} days allowed.`;
          this.userForm.dateOfBirth = '';
          return;
        }

        // Check for leap year February validation
        if (month === 2 && day === 29 && !this.isLeapYear(year)) {
          this.dateError = `${year} is not a leap year. February can only have 28 days.`;
          this.userForm.dateOfBirth = '';
          return;
        }
      }
    },

    isLeapYear(year) {
      return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
    },

    getMonthName(month) {
      const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      return months[month - 1];
    },

    validateForm() {
      // Clear any previous date errors
      this.dateError = '';

      // Check required fields
      if (!this.userForm.title || !this.userForm.fullName) {
        this.showAlert('failed', 'Please fill in all required personal information fields');
        return false;
      }

      if (!this.userForm.gender) {
        this.showAlert('failed', 'Please select a gender');
        return false;
      }

      // Validate date of birth if provided
      if (this.userForm.dateOfBirth) {
        this.validateDateOfBirth();
        if (this.dateError) {
          this.showAlert('failed', this.dateError);
          return false;
        }
      }

      if (!this.userForm.username || !this.userForm.email || !this.userForm.phone || !this.userForm.nationalId) {
        this.showAlert('failed', 'Please fill in all required contact information fields');
        return false;
      }

      // Check validation states
      if (!this.usernameValidation.isValid) {
        this.showAlert('failed', 'Please provide a valid and available username');
        return false;
      }

      if (!this.emailValidation.isValid) {
        this.showAlert('failed', 'Please provide a valid and available email address');
        return false;
      }

      if (!this.phoneValidation.isValid) {
        this.showAlert('failed', 'Please provide a valid and available phone number');
        return false;
      }

      if (!this.nationalIdValidation.isValid) {
        this.showAlert('failed', 'Please provide a valid and available National ID');
        return false;
      }

      if (!this.userForm.password || !this.userForm.confirmPassword) {
        this.showAlert('failed', 'Please enter password and confirm password');
        return false;
      }

      // Validate password match
      if (this.userForm.password !== this.userForm.confirmPassword) {
        this.showAlert('failed', 'Passwords do not match');
        return false;
      }

      // Validate password strength (minimum 4 characters)
      if (this.userForm.password.length < 4) {
        this.showAlert('failed', 'Password must be at least 4 characters long');
        return false;
      }

      // Validate email format
      if (!this.isValidEmail(this.userForm.email)) {
        this.showAlert('failed', 'Please enter a valid email address');
        return false;
      }

      // Validate phone number format
      if (!this.isValidPhone(this.userForm.phone)) {
        this.showAlert('failed', 'Please enter a valid phone number');
        return false;
      }

      if (!this.userForm.category || !this.userForm.departmentId || !this.userForm.employmentTypeId) {
        this.showAlert('failed', 'Please fill in all required work information fields');
        return false;
      }

      return true;
    },

    async registerUser() {
      if (!this.validateForm()) {
        return;
      }

      this.loading = true;
      this.clearAlerts();

      // Prepare data for submission
      const data = {
        function: "createUser",
        title: this.userForm.title,
        fullName: this.userForm.fullName,
        dateOfBirth: this.userForm.dateOfBirth || null,
        gender: this.userForm.gender,
        username: this.userForm.username,
        email: this.userForm.email,
        phone: this.userForm.phone,
        nationalId: this.userForm.nationalId,
        password: this.userForm.password,
        regionId: this.userForm.regionId || null,
        zoneId: this.userForm.zoneId || null,
        woredaId: this.userForm.woredaId || null,
        category: this.userForm.category,
        departmentId: this.userForm.departmentId,
        employmentTypeId: this.userForm.employmentTypeId,
        affiliationId: this.userForm.affiliationId || null,
        hospitalId: this.userForm.hospitalId || null,
        employeeId: this.userForm.employeeId || '',
        notes: this.userForm.notes || ''
      };

      try {
        const response = await executeJson(data, authUrl);

        if (response.data.success) {
          // Store user data for modal
          this.createdUser.username = response.data.data?.username || this.userForm.username;
          this.createdUser.userId = response.data.data?.userId || 'N/A';

          // Show success modal instead of alert
          this.showSuccessModal = true;

          // Also show a brief success alert
          this.showAlert('success', 'User created successfully!');

          // Clear form with persistent data
          this.clearForm(true);
        } else {
          this.showAlert('failed', response.data.message || 'Failed to create user. Please check your inputs.');
        }
      } catch (error) {
        console.error("Registration error:", error);
        this.showAlert('failed', error.response?.data?.message || error.message || 'An error occurred while creating user');
      } finally {
        this.loading = false;
      }
    },

    togglePassword() {
      this.showPassword = !this.showPassword;
    },

    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },

    clearAlerts() {
      this.alert.success = false;
      this.alert.info = false;
      this.alert.failed = false;
      this.message = '';
    },

    showAlert(type, message) {
      this.clearAlerts();
      this.alert[type] = true;
      this.message = message;

      // Auto-hide success/info alerts after 5 seconds
      if (type === 'success' || type === 'info') {
        setTimeout(() => {
          this.clearAlerts();
        }, 5000);
      }
    },

    // Updated clearForm method with parameter
    clearForm(keepPersistentData = true) {
      // Store current persistent selections before clearing if requested
      const currentSelections = keepPersistentData ? {
        title: this.userForm.title,
        regionId: this.userForm.regionId,
        zoneId: this.userForm.zoneId,
        woredaId: this.userForm.woredaId,
        category: this.userForm.category,
        departmentId: this.userForm.departmentId,
        employmentTypeId: this.userForm.employmentTypeId,
        affiliationId: this.userForm.affiliationId,
        hospitalId: this.userForm.hospitalId
      } : {};

      // Reset form to initial state
      this.userForm = {
        title: '',
        fullName: '',
        dateOfBirth: '',
        gender: '',
        username: '',
        email: '',
        phone: '',
        nationalId: '',
        password: '',
        confirmPassword: '',
        regionId: '',
        zoneId: '',
        woredaId: '',
        category: '',
        departmentId: '',
        employmentTypeId: '',
        affiliationId: '',
        hospitalId: '',
        employeeId: '',
        notes: ''
      };

      // Reset validation states
      this.usernameValidation = {
        checking: false,
        status: '',
        message: '',
        messageClass: 'text-muted',
        icon: 'bx bx-info-circle',
        isValid: false
      };

      this.emailValidation = {
        checking: false,
        status: '',
        message: '',
        messageClass: 'text-muted',
        icon: 'bx bx-info-circle',
        isValid: false
      };

      this.phoneValidation = {
        checking: false,
        status: '',
        message: '',
        messageClass: 'text-muted',
        icon: 'bx bx-info-circle',
        isValid: false
      };

      this.nationalIdValidation = {
        checking: false,
        status: '',
        message: '',
        messageClass: 'text-muted',
        icon: 'bx bx-info-circle',
        isValid: false
      };

      // Restore persistent selections only if requested
      if (keepPersistentData) {
        this.userForm.title = currentSelections.title;
        this.userForm.regionId = currentSelections.regionId;
        this.userForm.zoneId = currentSelections.zoneId;
        this.userForm.woredaId = currentSelections.woredaId;
        this.userForm.category = currentSelections.category;
        this.userForm.departmentId = currentSelections.departmentId;
        this.userForm.employmentTypeId = currentSelections.employmentTypeId;
        this.userForm.affiliationId = currentSelections.affiliationId;
        this.userForm.hospitalId = currentSelections.hospitalId;
      } else {
        // If not keeping persistent data, also clear localStorage
        this.clearSavedSelections();
        // Reset dependent dropdowns
        this.zones = [];
        this.woredas = [];
      }

      // Clear any alerts and errors
      this.clearAlerts();
      this.dateError = '';

      // Reset password visibility
      this.showPassword = false;
      this.showConfirmPassword = false;

      // Reset user data
      this.createdUser = {
        username: '',
        userId: ''
      };
    },

    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    isValidPhone(phone) {
      // Ethiopian phone number format (supports both with and without country code)
      const phoneRegex = /^(\+?251|0)?[0-9]{9}$/;
      return phoneRegex.test(phone.replace(/\s/g, ''));
    }
  },

  // Watch for debugging and reactivity
  watch: {
    'userForm.category': {
      handler(newVal) {
        // Role selection changed - can add any logic here if needed
      }
    }
  }
};
</script>

<style scoped>
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.form-control:disabled {
  background-color: #e9ecef;
  opacity: 0.6;
}

.bg-soft {
  background-color: rgba(52, 195, 143, 0.18) !important;
}

.text-warning {
  color: #f1b44c !important;
}

.text-muted {
  color: #74788d !important;
}

.text-danger {
  color: #dc3545 !important;
}

.text-success {
  color: #28a745 !important;
}

.text-info {
  color: #17a2b8 !important;
}

/* Add loading animation for dropdowns */
select.form-control:empty {
  background: #f8f9fa;
}

/* Improve alert styling */
.alert {
  border-radius: 0.25rem;
  border: none;
  box-shadow: 0 0.125rem 0.25rem rgba(0,0,0,0.075);
}

.alert .btn-close {
  padding: 0.5rem;
  margin-left: auto;
}

/* Password toggle button styling */
.input-group .btn-light {
  border: 1px solid #ced4da;
  background-color: #fff;
}

.input-group .btn-light:hover {
  background-color: #f8f9fa;
}

/* Success Modal Styling */
.modal.show {
  animation: fadeIn 0.3s ease-in-out;
}

.modal-content {
  border-radius: 0.5rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.modal-header.bg-success {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.modal-body .mdi-account-check {
  animation: bounceIn 0.6s ease-in-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.8); }
  to { opacity: 1; transform: scale(1); }
}

@keyframes bounceIn {
  0%, 20%, 53%, 80%, 100% {
    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
    transform: translate3d(0,0,0);
  }
  40%, 43% {
    animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
    transform: translate3d(0, -30px, 0);
  }
  70% {
    animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
    transform: translate3d(0, -15px, 0);
  }
  90% {
    transform: translate3d(0,-4px,0);
  }
}

/* Button improvements */
.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

/* Alert improvements */
.alert {
  border-radius: 0.375rem;
  border: none;
  box-shadow: 0 0.125rem 0.25rem rgba(0,0,0,0.075);
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Date validation error styling */
.text-danger {
  color: #e74c3c !important;
  font-size: 0.875rem;
}

.form-control.is-invalid {
  border-color: #e74c3c;
  box-shadow: 0 0 0 0.2rem rgba(231, 76, 60, 0.25);
}

/* Form validation styling */
.form-control.is-valid {
  border-color: #28a745;
  padding-right: calc(1.5em + 0.75rem);
  background-image: none;
}

.form-control.is-invalid {
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem);
  background-image: none;
}

/* Position utilities for validation icons */
.position-relative {
  position: relative;
}

.position-absolute {
  position: absolute;
}

.top-50 {
  top: 50%;
}

.end-0 {
  right: 0;
}

.translate-middle-y {
  transform: translateY(-50%);
}

.me-3 {
  margin-right: 1rem;
}

/* Spinner styles */
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: .25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border .75s linear infinite;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: .2em;
}

@keyframes spinner-border {
  to { transform: rotate(360deg); }
}

.visually-hidden {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

/* Icon sizes */
.fs-5 {
  font-size: 1.25rem !important;
}

/* Bootstrap icons */
.bx {
  font-family: 'boxicons' !important;
  font-weight: normal;
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
  display: inline-block;
  text-transform: none;
  speak: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>